/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ExperimentalHeartbeatUserType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditorStopHeartbeatMutation
// ====================================================

export interface EditorStopHeartbeatMutation {
  experimentalEditorStopHeartbeat: boolean | null;
}

export interface EditorStopHeartbeatMutationVariables {
  contentId: string;
  contentType: string;
  heartbeatUserType?: ExperimentalHeartbeatUserType | null;
}
